import { SkeletonLoader as RadialSkeletonLoader } from 'cdk-radial';
import { LoaderStyle, StyledSkeletonLoaderProps } from './types';
import type { FC } from 'react';

export const SkeletonLoader: FC<StyledSkeletonLoaderProps> = props => (
  <RadialSkeletonLoader
    height={LoaderStyle.height100}
    width={LoaderStyle.width100}
    {...props}
  />
);
